<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Button from '@mobile/components/Button/Button.vue'
import * as popup from '@mobile/globalState/popup'
import { PopupContext } from '@mobile/views/Relation/Shared/Popup/builder/types'
import { NumberOfRunsPopup } from '@mobile/views/Relation/Sports/Cricket/Popups/NumberOfRuns/NumberOfRunsPopup'

export default defineComponent({
  components: { Button },
  props: {
    context: {
      type: Object as PropType<PopupContext | null>,
      required: false,
    },
  },
  setup(props) {
    function handleClick(): void {
      if (props.context) {
        props.context?.openPopup(NumberOfRunsPopup)
      } else {
        popup.show({
          component: NumberOfRunsPopup,
          showHeader: true,
        })
      }
    }

    return { handleClick }
  },
})
</script>

<template>
  <Button
    :size="'sm'"
    :color="'white'"
    :withIcon="false"
    :type="'horizontal'"
    @click="handleClick"
  >
    Runs
  </Button>
</template>
